import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './TableList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
const toBool = (v) => v === true || v === 1 || v === '1' || v === 'true';

export default function AdminClubReferees() {
  const { id } = useParams(); // club_id din URL
  const navigate = useNavigate();
  const token = localStorage.getItem('adminToken');

  const [referees, setReferees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [searchTerm, setSearchTerm] = useState('');

  const [clubName, setClubName] = useState(""); 
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [newReferee, setNewReferee] = useState({
    first_name: '',
    last_name: '',
    birth_year: '',
    cnp: '',
    email: '',
    phone: '',
    nr_legitimatie: ''
  });

  const [editReferee, setEditReferee] = useState(null);

    /* =====================================================
     🔹 Fetch nume club
  ===================================================== */
  useEffect(() => {
    const fetchClubName = async () => {
      try {
        const res = await fetch(`https://www.fro.ro/api/admins/get-club.php?id=${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data.success) setClubName(data.club.name);
        else setClubName("(club necunoscut)");
      } catch {
        setClubName("(club necunoscut)");
      }
    };
    fetchClubName();
  }, [id, token]);


  /* =====================================================
     🔹 Fetch arbitri club
  ===================================================== */
  const fetchReferees = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://www.fro.ro/api/referees/index.php?club_id=${id}&year=${selectedYear}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();

      if (data.success) {
        setReferees(data.data || []);
        setError(null);
      } else {
        setError(data.message || 'Eroare la încărcarea arbitrilor');
      }
    } catch (err) {
      setError('Eroare conexiune: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReferees();
  }, [id, selectedYear]);

  /* =====================================================
     🔹 Legitimare arbitru (dacă ai endpoint)
  ===================================================== */
  const handleLegitimare = async (referee) => {
    const confirm = window.confirm(
      `Sigur vrei să legitimezi arbitrul ${referee.first_name} ${referee.last_name} pentru anul ${selectedYear}?`
    );
    if (!confirm) return;

    try {
      const res = await fetch('https://www.fro.ro/api/referees/legitimeaza-arbitru.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          referee_id: referee.id,
          club_id: id,
          year: selectedYear,
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert(`Legitimare efectuată. Taxa: ${data.taxa} lei.`);
        fetchReferees();
      } else {
        alert(data.message || 'Eroare la legitimare.');
      }
    } catch (err) {
      alert('Eroare conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Ștergere arbitru
  ===================================================== */
  const handleDelete = async (refereeId) => {
    if (!window.confirm('Sigur dorești să ștergi acest arbitru?')) return;

    try {
      const res = await fetch(
        `https://www.fro.ro/api/referees/delete.php?id=${refereeId}`,
        {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await res.json();

      if (data.success) {
        alert('Arbitru șters.');
        fetchReferees();
      } else {
        alert(data.message || 'Eroare la ștergere.');
      }
    } catch (err) {
      alert('Eroare la conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Adăugare arbitru
  ===================================================== */
  const handleAddReferee = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://www.fro.ro/api/referees/create.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...newReferee, club_id: id }),
      });

      const data = await res.json();
      if (data.success) {
        alert('Arbitru adăugat cu succes!');
        setShowAddModal(false);
        setNewReferee({
          first_name: '',
          last_name: '',
          birth_year: '',
          cnp: '',
          email: '',
          phone: '',
          nr_legitimatie: '',
        });
        fetchReferees();
      } else {
        alert(data.message || 'Eroare la adăugare.');
      }
    } catch (err) {
      alert('Eroare la conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Editare arbitru
  ===================================================== */
  const handleEditReferee = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://www.fro.ro/api/referees/edit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editReferee),
      });

      const data = await res.json();
      if (data.success) {
        alert('Arbitru actualizat cu succes!');
        setShowEditModal(false);
        setEditReferee(null);
        fetchReferees();
      } else {
        alert(data.message || 'Eroare la actualizare.');
      }
    } catch (err) {
      alert('Eroare la conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Filtrare arbitri
  ===================================================== */
  const filteredReferees = referees.filter((r) =>
    `${r.first_name} ${r.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* =====================================================
     🔹 UI
  ===================================================== */
  if (loading) return <p>Se încarcă arbitrii...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div className="table-list-container">
      <div className="table-list-header">
         <button className="back-btn" onClick={() => navigate(-1)}>
                    ⬅Înapoi
                </button>
                    <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className="year-dropdown"
          >
            {[new Date().getFullYear(), new Date().getFullYear() + 1].map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>

         <h2>Arbitri – {clubName ? clubName : `Club #${id}`}</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
       
      
          <input
            type="text"
            placeholder="Caută arbitru..."
            className="search-bar"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <button
            className="add-circle-btn"
            onClick={() => setShowAddModal(true)}
            aria-label="Adaugă arbitru"
          >
            <span className="plus-icon">+</span>
          </button>
        </div>
      </div>

      <table className="table-list">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nume</th>
            <th>An naștere</th>
            <th>CNP</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Activat</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {filteredReferees.length === 0 ? (
            <tr><td colSpan={8}>Nu există arbitri.</td></tr>
          ) : (
            filteredReferees.map((r) => (
              <tr key={r.id} className={toBool(r.is_legitimated) ? 'active-row' : ''}>
                <td>{r.id}</td>
                <td>{r.first_name} {r.last_name}</td>
                <td>{r.birth_year}</td>
                <td>{r.cnp}</td>
                <td>{r.email || '-'}</td>
                <td>{r.phone || '-'}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={toBool(r.is_legitimated)}
                    disabled={toBool(r.is_legitimated)}
                    onChange={() => handleLegitimare(r)}
                  />
                </td>
                <td className="table-list-actions">
  <button className="action-btn edit" onClick={() => { setEditReferee(r); setShowEditModal(true); }}>
    <FontAwesomeIcon icon={faPen} />
  </button>
  <button className="action-btn delete" onClick={() => handleDelete(r.id)}>
    <FontAwesomeIcon icon={faTrash} />
  </button>
</td>

              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* 🔹 Modal adăugare arbitru */}
      {showAddModal && (
        <div className="modal-backdrop" onClick={() => setShowAddModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Adaugă arbitru</h3>
            <form onSubmit={handleAddReferee} className="modal-form">
              <label>Prenume</label>
              <input type="text" value={newReferee.first_name} onChange={(e) => setNewReferee({ ...newReferee, first_name: e.target.value })} required />
              <label>Nume</label>
              <input type="text" value={newReferee.last_name} onChange={(e) => setNewReferee({ ...newReferee, last_name: e.target.value })} required />
              <label>An naștere</label>
              <input type="number" value={newReferee.birth_year} onChange={(e) => setNewReferee({ ...newReferee, birth_year: e.target.value })} required />
              <label>CNP</label>
              <input type="text" value={newReferee.cnp} onChange={(e) => setNewReferee({ ...newReferee, cnp: e.target.value })} required />
              <label>Email</label>
              <input type="email" value={newReferee.email} onChange={(e) => setNewReferee({ ...newReferee, email: e.target.value })} />
              <label>Telefon</label>
              <input type="text" value={newReferee.phone} onChange={(e) => setNewReferee({ ...newReferee, phone: e.target.value })} />
              <div className="modal-actions">
                <button type="submit" className="save-btn">Salvează</button>
                <button type="button" className="cancel-btn" onClick={() => setShowAddModal(false)}>Anulează</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* 🔹 Modal editare arbitru */}
      {showEditModal && editReferee && (
        <div className="modal-backdrop" onClick={() => setShowEditModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Editează arbitru</h3>
            <form onSubmit={handleEditReferee} className="modal-form">
              <label>Prenume</label>
              <input type="text" value={editReferee.first_name} onChange={(e) => setEditReferee({ ...editReferee, first_name: e.target.value })} required />
              <label>Nume</label>
              <input type="text" value={editReferee.last_name} onChange={(e) => setEditReferee({ ...editReferee, last_name: e.target.value })} required />
              <label>An naștere</label>
              <input type="number" value={editReferee.birth_year} onChange={(e) => setEditReferee({ ...editReferee, birth_year: e.target.value })} required />
              <label>Email</label>
              <input type="email" value={editReferee.email} onChange={(e) => setEditReferee({ ...editReferee, email: e.target.value })} />
              <label>Telefon</label>
              <input type="text" value={editReferee.phone} onChange={(e) => setEditReferee({ ...editReferee, phone: e.target.value })} />
              <div className="modal-actions">
                <button type="submit" className="save-btn">Actualizează</button>
                <button type="button" className="cancel-btn" onClick={() => setShowEditModal(false)}>Anulează</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
